var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item[_vm.field])?_c('label',{class:[_vm.$style.text, _vm.getLabelClasses()]},[_vm._v(" New ")]):_c('label',{class:[_vm.$style.text, _vm.getLabelClasses()]},[_vm._v(" Imported ")])
}
var staticRenderFns = []

export { render, staticRenderFns }